import "@hotwired/turbo-rails"
import "bootstrap/js/dist/collapse"
import { application } from "./controllers/application"
import RevealController from "./controllers/reveal_controller"

application.register("reveal", RevealController)
